import { useVisitSession } from "@/modules/visitSession/stores/visitSession";

export function installSiteVisitsTracker({ router, pinia }) {
  router.afterEach(() => {
    const store = useVisitSession(pinia);
    // solo cuenta si la ruta actual (to) tiene meta.countViews === true
    const to = router.currentRoute.value;
    if (!to.meta || to.meta.countViews !== true) return;
    store.track();
  });
}
